import React from 'react';
import LoaderImage from "./../../asset/loader.gif";


const Loader = ({ message, className }) => {
  return (
    <div className={ className }>
       <img
            src= { LoaderImage }
            style={{ height: '90px'}}
            title= "Loading report"
            alt = "Loading report"
          />
        <p className="loader-text" style={{ marginTop: "92px" }}> { message } </p>
    </div>
  );
};

export default Loader;